export interface FormOptionsModel {
  description?: string;
  columns: number;
  tabs: Array<{ id: string; name: string }>;
}
